import React from 'react';
import { MonitorTask } from '../../services/klineMonitorService';

interface MonitorControlPanelProps {
  monitoring: boolean;
  toggleLoading: boolean;
  toggleMonitoring: () => void;
  enableAutoTrading: boolean;
  setEnableAutoTrading: (value: boolean) => void;
  monitorData: MonitorTask | null;
}

const MonitorControlPanel: React.FC<MonitorControlPanelProps> = ({
  monitoring,
  toggleLoading,
  toggleMonitoring,
  enableAutoTrading,
  setEnableAutoTrading,
  monitorData,
}) => {
  return (
    <div className="flex items-end justify-between mb-4">
      <div className="flex items-end gap-3">
        <button
          onClick={toggleMonitoring}
          disabled={toggleLoading}
          className={`px-4 py-2 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 ${
            monitoring
              ? 'bg-red-500/20 text-red-200 border border-red-500/40 hover:bg-red-500/30'
              : 'bg-green-500/20 text-green-200 border border-green-500/40 hover:bg-green-500/30'
          } ${toggleLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {toggleLoading ? (
            <>
              <svg
                className="animate-spin h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span>{monitoring ? '停止中...' : '启动中...'}</span>
            </>
          ) : (
            <span>{monitoring ? '⏸ 停止监控' : '▶ 开始监控'}</span>
          )}
        </button>
        {!monitoring && (
          <label className="flex items-center gap-2 text-white/70 text-sm cursor-pointer">
            <input
              type="checkbox"
              checked={enableAutoTrading}
              onChange={(e) => setEnableAutoTrading(e.target.checked)}
              className="w-4 h-4 rounded border-white/30 bg-white/10 text-green-500 focus:ring-green-500 focus:ring-offset-0 focus:ring-offset-transparent focus:ring-2"
            />
            <span>启用自动交易</span>
          </label>
        )}
      </div>
      {monitoring && (
        <div className="flex items-center gap-3 text-sm">
          {monitorData?.enableAutoTrading && (
            <div className="flex items-center gap-2 text-blue-400">
              <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
              <span>交易中...</span>
            </div>
          )}
          <div className="flex items-center gap-2 text-green-400">
            <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span>监控中...</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MonitorControlPanel;
